
import { Component, Vue } from 'vue-property-decorator';

import SubheaderItem from '@/components/header/SubheaderItem.vue';

@Component({
    name: 'Subheader',
    components: {
        SubheaderItem,
    },
})
export default class Subheader extends Vue {}
